
<div class="organize-search-box">
  <div class="organize-search-title">{{ 'games.organize.select_team_title' | translate }}</div>
  <form id="organize-search-form" [formGroup]="searchForm">
    <div class="input-group">
      <div class="left-icon"><img [src]="utils.imageUrl('ecl-teams.png')" alt=""></div>
      <input id="search_team" name="search_team" formControlName="search_team" [placeholder]="'games.organize.search_placeholder' | translate" autocomplete="off">
    </div>
  </form>
</div>

<div [nbSpinner]="loading()"
     nbSpinnerStatus="danger"
     nbSpinnerSize="large"
     nbSpinnerMessage="">
  @if(organizeGameTeams()?.data && organizeGameTeams()?.data.length > 0) {
    @for (team of organizeGameTeams()?.data; track team.team_id) {
      <div class="games-card organize-team-card">
        <div class="organize-team-logo">
          <img src="{{utils.teamImageUrl(team)}}" alt="Team"/>
        </div>
        <div class="organize-team-body">
          <div class="organize-team-name">{{ team.name }}</div>
          <div class="organize-team-division">{{ selectedDivisionName() }} - {{ selectedGroupName() }}</div>
        </div>
        <div class="organize-team-button">
          <button nbButton outline status="primary" (click)="openOrganizeForm(selectedDivisionIdSignal, selectedGroupIdSignal, team)">{{ 'games.organize.organize_btn' | translate }}</button>
        </div>
      </div>
    }
  }
  @else {
    <div class="no-data">{{ 'games.organize.no_team' | translate }}</div>
  }
</div>
